<mat-toolbar color="primary" class="mat-elevation-z4">
    <span>Summary of Selected Analytes</span>
</mat-toolbar>
<div class="list-container">
    <mat-list>
        <mat-list-item *ngFor="let analyte of data.analytes">
            <span>{{ analyte.name }} was selected {{ analyte.timesSelected }} time{{analyte.timesSelected > 1
                ?'s':''}}</span>
        </mat-list-item>
    </mat-list>
</div>
<div class="message-container">
    <h3>Are you sure you want to continue?</h3>
</div>
<div class="actions-container">
    <button mat-raised-button data-testid="lp-sample-summary-no-button" (click)="onCancel()">No</button>
    <button mat-raised-button color="primary" data-testid="lp-sample-summary-yes-button" (click)="onContinue()">Yes</button>
</div>